export const SOFTLINE_API_PRUEFPROTOKOLL = '/v1/prueflog/entities'
export const SOFTLINE_API_AKTIVITAETEN = '/v1/aktivitaet/entities'
export const SOFTLINE_API_PRUEFPROTOKOLL_LAGERPLATZ_SCAN = '/v1/lagerplatz/scan/{{code}}'
